import { useCallback } from "react";
import appLogger from "../../infra/logger/appLogger";
import { useAppDispatch, useAppSelector } from "../hook";
import { updateConversationRulebookSettings } from "./rulebookSlice";
const rulebookLogger = appLogger.withTag("Rulebook");
const EMPTY_SETTINGS = {};
export default function useConversationRulebookSettings({ conversationId }) {
    const dispatch = useAppDispatch();
    const settings = useAppSelector((state) => conversationId ? (state.rulebook.settingsByConversationId[conversationId] ?? EMPTY_SETTINGS) : EMPTY_SETTINGS);
    const updateSettings = useCallback((patch) => {
        if (!conversationId) {
            return;
        }
        dispatch(updateConversationRulebookSettings({ conversationId, settings: patch }))
            .unwrap()
            .catch((error) => {
            rulebookLogger.error("Failed to update conversation rulebook settings", error);
        });
    }, [conversationId, dispatch]);
    const setFrozen = useCallback((frozen) => updateSettings({ frozen }), [updateSettings]);
    const setHudHidden = useCallback((hidden) => updateSettings({ hud_hidden: hidden }), [updateSettings]);
    return { settings, setFrozen, setHudHidden };
}
